import { AfterContentInit, Component, ContentChildren, QueryList, ViewEncapsulation } from '@angular/core';
import { TabComponent } from './tab.component';

@Component({
  selector: 'app-tabs',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="tab-list" role="tablist">
      <button
        *ngFor="let tab of tabs; let i = index"
        class="tab-button"
        [class.active]="tab.active"
        (click)="selectTab(tab)"
        role="tab"
        [attr.aria-selected]="tab.active"
        type="button"
      >
        {{ tab.header }}
      </button>
    </div>
    <div class="tab-content">
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    app-tabs { display: block; }
    app-tabs .tab-list {
      display: flex !important;
      border-bottom: 2px solid #e5e7eb;
      gap: 0;
      margin-bottom: 0;
    }
    app-tabs .tab-list .tab-button {
      padding: 0.75rem 1.25rem !important;
      font-size: 0.9375rem !important;
      font-weight: 500;
      color: #6b7280;
      background: none !important;
      border: none !important;
      border-bottom: 2px solid transparent !important;
      margin-bottom: -2px;
      cursor: pointer;
      transition: color 0.15s, border-color 0.15s;
      white-space: nowrap;
    }
    app-tabs .tab-list .tab-button:hover { color: #1f2937; }
    app-tabs .tab-list .tab-button.active {
      color: #ea5b0c !important;
      border-bottom-color: #ea5b0c !important;
    }
    app-tabs .tab-content { padding-top: 1rem; }
  `]
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent, { descendants: true }) tabs!: QueryList<TabComponent>;

  ngAfterContentInit(): void {
    // Initial selection
    this.initTabs();

    // Re-check when tabs change dynamically (e.g. *ngIf, *appGranted)
    this.tabs.changes.subscribe(() => {
      this.initTabs();
    });
  }

  private initTabs(): void {
    if (this.tabs.length > 0 && !this.tabs.some(t => t.active)) {
      this.selectTab(this.tabs.first);
    }
  }

  selectTab(tab: TabComponent): void {
    this.tabs.forEach(t => t.active = false);
    tab.active = true;
  }
}
